import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Home from './screens/Home';
import SignOrder from './screens/SignOrder';
import Deploy from './screens/Deploy';
import Deposit from './screens/Deposit';
import Withdraw from './screens/Withdraw';
import Swap from './screens/Swap';
import Approvals from './screens/Approvals';
import Bridge from './screens/Bridge';
import Rescue from './screens/Rescue';
import DevIndex from './screens/DevIndex';
import Markets from './screens/Markets';
import MarketList from './screens/MarketList';
import MarketDetail from './screens/MarketDetail';
import Portfolio from './screens/Portfolio';
import Orders from './screens/Orders';
import Ranking from './screens/Ranking';
import Copy from './screens/Copy';
import CopyLeader from './screens/CopyLeader';
import CopyConfirm from './screens/CopyConfirm';
import Help from './screens/Help';
import Settings from './screens/Settings';
import { DEV_PREVIEW } from './devPreview';
import { NavStackProvider } from './lib/nav-stack';

export default function App() {
  return (
    <BrowserRouter>
      <NavStackProvider>
        <Routes>
          <Route path="/" element={DEV_PREVIEW ? <DevIndex /> : <Home />} />
          <Route path="/dev" element={<DevIndex />} />
          <Route path="/home" element={<Home />} />
          <Route path="/sign-order" element={<SignOrder />} />
          <Route path="/deploy-wallet" element={<Deploy />} />
          <Route path="/deposit" element={<Deposit />} />
          <Route path="/withdraw" element={<Withdraw />} />
          <Route path="/swap" element={<Swap />} />
          <Route path="/approvals" element={<Approvals />} />
          <Route path="/bridge" element={<Bridge />} />
          <Route path="/rescue/:mode" element={<Rescue />} />
          <Route path="/markets" element={<Markets />} />
          <Route path="/markets/cat/:catKey" element={<MarketList />} />
          <Route path="/markets/search/:q" element={<MarketList />} />
          <Route path="/markets/m/:slug" element={<MarketDetail />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/orders" element={<Orders />} />
          <Route path="/ranking" element={<Ranking />} />
          <Route path="/copy" element={<Copy />} />
          <Route path="/copy/leader/:address" element={<CopyLeader />} />
          <Route path="/copy/confirm/:notificationId" element={<CopyConfirm />} />
          <Route path="/help" element={<Help />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="*" element={DEV_PREVIEW ? <DevIndex /> : <Home />} />
        </Routes>
      </NavStackProvider>
    </BrowserRouter>
  );
}
